var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header'):_vm._e(),_c('el-container',{staticClass:"content"},[(_vm.showHeader)?_c('Menu'):_vm._e(),_c('el-container',[_c('el-main',[(_vm.showBread)?_c('Bread'):_vm._e(),_c('div',{staticClass:"cont"},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }